const brands = [
    'Acson',
    'Admiral',
    'AEG',
    'Ager',
    'Airton',
    'Airwell',
    'Akai',
    'Akira',
    'Alliance',
    'Alpha Smart',
    'Alpin',
    'Amana',
    'Amcor',
    'Amely',
    'Amena',
    'American Standard',
    'Anslut',
    'Arctic',
    'Argo',
    'Ariston',
    'Arlec',
    'Artel',
    'Aucma',
    'Autoclima',
    'Aux',
    'Ayre',
    'Ballu',
    'Banshen',
    'Beko',
    'Black & Decker',
    'Blue Star',
    'Blueway',
    'Boerka',
    'Bonaire',
    'Bosch',
    'Braemar',
    'Brivis',
    'Bryant',
    'Carrier',
    'Celestial',
    'Centrex',
    'Changhong',
    'Chigo',
    'Chofu',
    'Chunlan',
    'Clatronic',
    'Climaveneta',
    'Climette',
    'Close Comfort',
    'Cold Point',
    'Comfee',
    'Comfort-Aire',
    'ComfortStar',
    'Condura',
    'Conrowa',
    'Consul',
    'Cooline',
    'Coolman',
    'Cooper & Hunter',
    'Corona',
    'Croma',
    'Cruisair',
    'Daewoo',
    'Daijitsu',
    'Daikin',
    'Danby',
    'Daya',
    'DEC',
    'DEI',
    'Delonghi',
    'Demir Dokum',
    'Derby',
    'Dimplex',
    'DL',
    'Doctor',
    'Domain',
    'Dometic',
    'Domoto',
    'Dongbao',
    'Dongxinbao',
    'Dunham Bush',
    'Dynamic',
    'Dyson',
    'Electra',
    'Electrolux',
    'Elegance',
    'Elexa',
    'Emailair',
    'Emerson',
    'Emmeti',
    'Eubank',
    'Europace',
    'Excel',
    'Fagor',
    'Family',
    'Fedders',
    'Ferroli',
    'Fidji',
    'Firstline',
    'Fisher',
    'Forestair',
    'Frestech',
    'Friedrich',
    'Frigidaire',
    'Fuji Electric',
    'Fujiaire',
    'Fujita',
    'Fujitsu',
    'Funai',
    'Galanz',
    'GE',
    'Genaire',
    'General',
    'General Electric',
    'Glee',
    'Godrej',
    'Goldstar',
    'Goodman',
    'Gree',
    'GUT',
    'Haier',
    'Haiku',
    'Harbor Point',
    'Heller',
    'Hisense',
    'Hisuper',
    'Hitachi',
    'Hofwell',
    'Honeywell',
    'Hotpoint',
    'Huabao',
    'Huake',
    'Hualing',
    'Huifeng',
    'Huikang',
    'Huke',
    'Hyundai',
    'Ikon',
    'Innova Air',
    'Innovair',
    'Islandaire',
    'IVT',
    'JBC',
    'JBS Airmaster',
    'JDC',
    'Jet Air',
    'Jetman',
    'Jinda',
    'Jinsong',
    'Johson',
    'Josen',
    'Kangli',
    'Kelon',
    'Kelvinator',
    'Kendo',
    'Kenmore',
    'Kenstar',
    'Klarstein',
    'Klimaire',
    'Klimatair',
    'Kogan',
    'Kolin',
    'Konka',
    'Koolsola',
    'Koppel',
    'Kosner',
    'Lakes',
    'Lasko',
    'Lennox',
    'Levante',
    'LG',
    'Little Duck',
    'Lloyd',
    'Loren-Sebo',
    'Lorenz',
    'Luko',
    'Luna Diamond',
    'Luxaire',
    'Mabe',
    'Maclaren',
    'Magnavox',
    'Marstair',
    'Maselino',
    'Mastercool',
    'Maxa',
    'Maytag',
    'McQuay',
    'Meaco',
    'MEC',
    'Media',
    'Meitav',
    'MeitavTec',
    'Micom',
    'Midea',
    'Miller',
    'Mirage',
    'Misakae',
    'Mistral',
    'Mitsubishi',
    'Mr Cool',
    'MultiAqua',
    'MyUBI',
    'Natec',
    'NEC',
    'Neocool',
    'Newair',
    'Nexus',
    'Nisato',
    'Nordstar',
    'Nortek',
    'Olimpia Splendid',
    'Omni',
    'Onsen',
    'Optical',
    'Orieme',
    'Pacific',
    'Panasonic',
    'Panda',
    'Paolo',
    'Parker',
    'Pearl',
    'Pensonic',
    'Philco',
    'Pilot',
    'Pioneer',
    'Polo Cool',
    'Polystar',
    'Prima',
    'Proton',
    'PYE',
    'Quietside',
    'Rasonic',
    'Raybo',
    'Remko',
    'Renwhit',
    'Rheem',
    'Riello',
    'Rinnai',
    'Rollibot',
    'Rolls',
    'Rowa',
    'Royal',
    'Royal Sovereign',
    'Russell Hobbs',
    'Sabro',
    'Saijo Denki',
    'Sampo',
    'Samsung',
    'Sankey',
    'Sanlux',
    'Sanyo',
    'Saporo',
    'Sasuki',
    'Saunier Duval',
    'Scanfrost',
    'Sea Breeze',
    'Sea-C',
    'Season',
    'Senville',
    'Sharp',
    'Shengfeng',
    'Shinco',
    'Shuaikang',
    'Shuanglu',
    'Signiture',
    'Sinclair',
    'Singer',
    'Skytec',
    'Skyworth',
    'Soleus',
    'Songge',
    'Sova',
    'Spacepak',
    'Spectra',
    'Spring Argo',
    'SPT',
    'Starway',
    'Starwin',
    'Steel',
    'Streamline',
    'Sunair',
    'Sunbeam',
    'Sundurg',
    'Sunpentown',
    'Surrey',
    'Swan',
    'Swift',
    'Tadiran',
    'Tatung',
    'Taurus',
    'TCL',
    'Teco',
    'Telesonic',
    'Telstar',
    'TempAir',
    'Temperzone',
    'TGM',
    'Thermocore',
    'Thermosphere',
    'Tia',
    'Tiandi',
    'Topaire',
    'Tornado',
    'Toshiba',
    'Tosot',
    'Totaline',
    'Tovlux',
    'Toyotomi',
    'Trane',
    'Trilec',
    'Tristar',
    'Tropigas',
    'Truma',
    'Uni-Air',
    'Union',
    'V-Lec',
    'Vaillant',
    'Vately',
    'Veito',
    'Vestel',
    'Videocon',
    'Voltas',
    'VS',
    'Weili',
    'Well',
    'Westair',
    'Westinghouse',
    'Weston',
    'Westpoint',
    'Whirlpool',
    'Whisper Aire',
    'Whynter',
    'Wilfa',
    'Windair',
    'Windy',
    'Winia',
    'Wolf Power',
    'Xileng',
    'Xinle',
    'Yair',
    'Yangzi',
    'Yconon',
    'Yokohama',
    'Yonan',
    'York',
    'Yunhai',
    'Zamil',
    'Zanussi',
    'Zephir',
    'Zhen Bao',
    'Zibro'
];
